
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exkursion",
      function () {
        return require("private-next-pages/exkursion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exkursion"])
      });
    }
  